// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__227vB","header":"Messages_header__2p57V"};